import 'normalize.css';
import './tachyons/css/tachyons.css';
import './src/styles';

import WrapProvider from './wrapProvider';

export const wrapRootElement = WrapProvider;
